import { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { deliveryInfoState } from "state";
import StringUtils from "utils/string";
import { AlternativeAutoComplete } from "../../../../component/form/autoComplete/_alternativeAutoComplete";
import ValidateMessage from "./ValidateMessage";

export default function DeliveryWard() {
  const cartAddress = useRecoilValue(deliveryInfoState);
  const setCartAddress = useSetRecoilState(deliveryInfoState);
  const { province, ward } = cartAddress;

  const [keyword, setKeyword] = useState("");
  const [touch, setTouch] = useState(false)
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setCartAddress({
      ...cartAddress,
      ward: {
        ...cartAddress.ward,
        list: cartAddress.ward.listOrigin,
      },
    });
    setOpen(true)
    setTouch(true)
  }

  const handleChange = (data) => {
    setCartAddress({
      ...cartAddress,
      ward: {
        ...cartAddress.ward,
        value: data,
      },
    });
  };

  const handleKeywordChange = (data) => {
    if (keyword === data.value) return;
    const keywordInput = data.value || "";
    const formatDataValue = keywordInput
      ? StringUtils.removeAcent(keywordInput.toLowerCase())
      : "";

    const listData = ward.listOrigin.filter((item) => {
      const formatNameItem = item?.name
        ? StringUtils.removeAcent(item.name.toLowerCase())
        : "";
      if (formatNameItem.includes(formatDataValue.trim())) return true;
      return false;
    });

    setKeyword((prev) => (prev !== keywordInput ? keywordInput : prev));
    setCartAddress(prev => ({
      ...prev,
      ward: {
        ...prev.ward,
        list: listData,
      },
    }));
  };

  useEffect(() => {
    setCartAddress({
      ...cartAddress,
      ward: {
        ...cartAddress.ward,
        validate: touch && !open && !cartAddress.ward.value ? 'Phường/Xã không được để trống' : ''
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [touch, open]);

  // useEffect(() => {
  //   if (JSON.stringify(ward.value) !== JSON.stringify(value))
  //     setValue(ward.value)
  // }, [ward, value])

  return (
    <div>
      <AlternativeAutoComplete
        // main input
        className={"store-update_input-edit"}
        inputProps={{
          categoryList: [], // menu list in category dropdown
          categoryValue: { name: "Phường/Xã", value: "" }, // if not exist this value -> default category: categoryList[0]
          categoryHidden: true,
          disabled: !province?.value,
          placeholder: "Chọn Phường/Xã",
          readOnly: true,
          value: ward.value?.name || "",
          validateText: ward.validate,
          validateType: 'danger',
          validateClass: 'hidden',
          onClick: handleOpen
        }}
        // search menu dropdown
        menuProps={{
          empty: ward?.list?.length <= 0 ? "Không tìm thấy Phường/Xã" : "",
        }}
        // search input in dropdown menu
        searchInputProps={{
          placeholder: "Tìm kiếm Phường/Xã",
          value: keyword || "",
          onChange: handleKeywordChange,
        }}
        onBackdrop={() => setOpen(false)}
      >
        {ward?.list?.length > 0 &&
          ward?.list.map((item) => (
            <div
              className="auto-complete__option card-filter-form__option-text"
              key={item.value}
              data-active={item.value === ward.value?.value}
              onClick={() => handleChange(item)}
            >
              {item.name}
            </div>
          ))}
      </AlternativeAutoComplete>
      <ValidateMessage>{ward.validate}</ValidateMessage>
    </div>
  );
}
